import { createContext, useContext, useState, useCallback } from "react";

const NavBarTitleContext = createContext({
  title: null,
  onBack: null,
  onRefresh: null,
  showBack: false,
  showRefresh: false,
  set: () => {},
  clear: () => {},
});

export function NavBarTitleProvider({ children }) {
  const [state, setState] = useState({
    title: null,
    onBack: null,
    onRefresh: null,
    showBack: false,
    showRefresh: false,
  });

  const set = useCallback(({ title, onBack, onRefresh, showBack = true, showRefresh = false }) => {
    setState({ title, onBack, onRefresh, showBack, showRefresh });
  }, []);

  const clear = useCallback(() => {
    setState({ title: null, onBack: null, onRefresh: null, showBack: false, showRefresh: false });
  }, []);

  return (
    <NavBarTitleContext.Provider value={{ ...state, set, clear }}>
      {children}
    </NavBarTitleContext.Provider>
  );
}

export function useNavBarTitle() {
  return useContext(NavBarTitleContext);
}
